<script setup>

</script>

<template>
<v-card class="card">

    <Skeletor width="100%" height="75" />

</v-card>
</template>

<style scoped>

.card {
    background: var(--primary-color);
    overflow: hidden;
    flex: 1;
    background-color: var(--primary-color);
    margin: 10px;
    height: 60px;
}
</style>
